bikeway_map_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;
        add_feature_handler.properties.selectedCategory = 'biking';
        step_one_handler.showContent();
        geojson_loader_handler.removeData();
        geojson_loader_handler.loadData('bike');

        if (properties.commentsToggle){
            $( "#map-comments" ).prop('checked', true);
            mapData.pointsLayer.clearLayers();
            mapData.lineStringLayer.clearLayers();
            geojson_loader_handler.loadComments('biking');

        }

    },


    events: function() {
        var self = this;
        self.onLoad();

        step_one_handler.events();

        $( "#map-comments" ).change(function() {
          var hide = $(this).is(':checked'); 
          
          if (hide){
            properties.commentsToggle = true;
            geojson_loader_handler.loadComments('biking');

          }
          else{
            properties.commentsToggle = false;
            mapData.pointsLayer.clearLayers();
            mapData.lineStringLayer.clearLayers();
          }
          return false;
        });


    }
}